/**
 * Ключи в localStorage для auth-state.
 *
 * Один источник правды — чтобы `http.ts` и `atoms/auth/` не разъезжались.
 * Менять только здесь.
 *
 * Два независимых контура авторизации (ADMIN_SPEC §0.1):
 *   • team   — команда Skrezo, вход логин+пароль, платформенная зона.
 *   • client — клиника/соло, вход телефон+OTP, кабинет клиники.
 * Токены разные и не должны пересекаться — отсюда раздельные ключи.
 */

/* ── Команда Skrezo (платформенная зона) ───────────────────────── */
export const TEAM_TOKEN_STORAGE_KEY = 'skrezo:team:token';
export const TEAM_USER_STORAGE_KEY = 'skrezo:team:user';
/** Refresh-токен команды: access живёт коротко, по refresh продлеваем без входа */
export const TEAM_REFRESH_STORAGE_KEY = 'skrezo:team:refresh';

export const readTeamRefresh = (): string | null => localStorage.getItem(TEAM_REFRESH_STORAGE_KEY);

export const writeTeamRefresh = (token: string | null): void => {
  if (token === null) localStorage.removeItem(TEAM_REFRESH_STORAGE_KEY);
  else localStorage.setItem(TEAM_REFRESH_STORAGE_KEY, token);
};

/* ── Клиент: клиника / соло (кабинет) ──────────────────────────── */
export const CLIENT_TOKEN_STORAGE_KEY = 'skrezo:client:token';
export const CLIENT_USER_STORAGE_KEY = 'skrezo:client:user';

/** Какой контур сейчас активен — по нему http.ts выбирает токен. */
export type AuthContour = 'team' | 'client';
